import { useState, useContext } from "react";
import { Checkbox, Button, Alert } from "@narmi/design_system";

import { CSRF_TOKEN } from "../../pages/csrf";

import { useUserConfiguration } from "../../hooks/useUserConfiguration";

import NotificationContext from "cerulean/src/NotificationContext";

import { handleErrorResponse } from "@utils/api";

export default function TermsAcceptance() {
  const { roles, permissions } = useUserConfiguration();
  const isNarmi = roles.narmi;
  const acceptancePerm = permissions.includes("backoffice.accept_legal_agreements");

  const { sendNotification } = useContext(NotificationContext);

  const [acceptanceChecked, setAcceptanceChecked] = useState(false);
  const checkboxDisclaimer =
    "By proceeding, I confirm I have reviewed and agree to the Terms of Service for Narmi Functions " +
    "outlined above and I represent that I have the authority to bind Client, its affiliates, and all users who " +
    "access Narmi Functions on its behalf to these Terms. If you do not have authority, you must not accept " +
    "these Terms and you may not use the Narmi Functions services.";

  async function onSubmit() {
    if (!acceptanceChecked) {
      sendNotification({
        type: "negative",
        text: "You must check the box to confirm your agreement.",
      });
      return;
    }
    const res = await fetch("/v1/product_terms", {
      method: "PUT",
      headers: {
        "X-CSRFToken": CSRF_TOKEN,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        feature: "narmi_functions",
        accepted: acceptanceChecked,
      }),
    });
    if (!res.ok) {
      const errMessage = await handleErrorResponse(res);
      sendNotification(errMessage);
      return;
    }
    window.location.reload();
  }

  return (
    <div className="padding--y">
      {acceptancePerm && !isNarmi ? (
        <div className="nds-container">
          <p>
            Please review the following terms which includes important information on the Narmi
            Functions service including pricing and your organization&apos;s responsibilities in
            using the service.
          </p>
          <h2 className="padding--y">Terms of Service for Narmi Functions</h2>
          <iframe
            title="Terms of service"
            style={{ width: "100%", height: "50em", border: 0 }}
            src="https://www.narmi.com/policies/functions-terms"
          />
          <Checkbox
            onChange={() => setAcceptanceChecked(!acceptanceChecked)}
            value={acceptanceChecked.toString()}
            label={checkboxDisclaimer}
          />
          <Button style={{ float: "right" }} label="Submit" onClick={() => onSubmit()} />
        </div>
      ) : (
        <div className="padding--x--l">
          <Alert isActive isDismissable={false}>
            An administrator must accept the Terms of Service for Narmi Functions before Narmi
            Functions can be used.
          </Alert>
        </div>
      )}
    </div>
  );
}
